// extracted by mini-css-extract-plugin
export var activeDot = "_8q-c";
export var buttonContainer = "_8q-9";
export var channelButton = "_8q-a";
export var clickable = "_8q-d";
export var content = "_8q-0";
export var contentFull = "_8q-2";
export var contentThird = "_8q-1";
export var contentWrapper = "_8q-7";
export var description = "_8q-5";
export var heightShort = "_8q-f";
export var image = "_8q-3";
export var imageContainer = "_8q-4";
export var selectButton = "_8q-e";
export var spinnerContainer = "_8q-b";
export var titleContent = "_8q-8";
export var titleWrapper = "_8q-6";